<div class="contact-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-7 col-md-12">
                <div class="contact-item">
                    <h2>{{ getInTouch.title }}</h2>

                    <form id="contactForm" (submit)="submitContactForm($event)">
                        <div class="row">

                            <div class="col-sm-6 col-lg-6">
                                <div class="form-group">
                                    <input type="text" name="visitor_name" id="name" class="form-control"
                                        [placeholder]="getInTouch.namePlaceholder" required>
                                </div>
                            </div>

                            <div class="col-sm-6 col-lg-6">
                                <div class="form-group">
                                    <input type="email" name="visitor_email" id="email" class="form-control"
                                        [placeholder]="getInTouch.emailPlaceholder" required>
                                </div>
                            </div>

                            <div class="col-sm-6 col-lg-6">
                                <div class="form-group">
                                    <input type="tel" name="visitor_phone" id="phone_number" class="form-control"
                                        [placeholder]="getInTouch.phonePlaceholder" required>
                                </div>
                            </div>

                            <div class="col-sm-6 col-lg-6">
                                <div class="form-group">
                                    <input type="text" name="inquiry_subject" id="msg_subject" class="form-control"
                                        [placeholder]="getInTouch.subjectPlaceholder">
                                </div>
                            </div>

                            <div class="col-md-12 col-lg-12">
                                <div class="form-group">
                                    <textarea name="visitor_message" class="form-control" id="message" cols="30"
                                        rows="8" [placeholder]="getInTouch.messagePlaceholder" required></textarea>
                                </div>
                            </div>

                            <div class="col-md-12 col-lg-12">
                                <button type="submit" class="contact-btn btn">
                                    {{ getInTouch.submitButtonText }}
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>

            <div class="col-lg-5 col-md-12">
                <div class="contact-item">
                    <h2>BLINK Productions</h2>

                    <div class="contact-address">
                        <div class="contact-inner">
                            <i class='bx bx-phone-call icon'></i>
                            <h4>Mob (Oman):</h4>
                            <a href="tel:+96893656556">+96893656556</a>
                        </div>


                        <div class="contact-inner">
                            <i class='bx bx-mail-send icon'></i>
                            <h4>Email:</h4>
                            <a href="mailto:abboud&#64;blink-productions.com">abboud&#64;blink-productions.com</a>
                        </div>

                        <div class="contact-inner">
                            <i class='bx bx-current-location icon'></i>
                            <h4>Address:</h4>
                            <span>Muscat - Oman</span>
                        </div>

                        <div class="contact-inner">
                            <i class='bx bx-phone-call icon'></i>
                            <h4>Mob (JOR):</h4>
                            <a href="tel:+962795222293">+962795222293</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="map-area">
    <iframe id="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.17866413849!2d58.401429576019176!3d23.562025895980703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ff837b43a1eb%3A0x18fc45df9d61855a!2sBlink%20Productions!5e0!3m2!1sen!2sus!4v1789652799280!5m2!1sen!2sus"
        width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="strict-origin-when-cross-origin"></iframe>
</div>